/**
 * Session-expiry signal between the API layer and the auth provider.
 *
 * `api/` cannot import `context/` — the provider already imports the API layer's
 * siblings and React has no place in a plain async fetch helper. So the 401 handler
 * publishes here and `AuthProvider` subscribes. Deliberately not a React context:
 * it has to be callable from outside the component tree.
 */

type SessionExpiredListener = () => void;

const listeners = new Set<SessionExpiredListener>();

/** Returns its own unsubscribe function so callers can clean up from a `useEffect`. */
export function onSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifySessionExpired(): void {
  listeners.forEach((listener) => listener());
}
